import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-lf font-bold mb-6" }
const _hoisted_2 = { class: "text-black font-light text-xs leading-relaxed whitespace-pre-line" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = ["src", "alt", "onClick"]
const _hoisted_5 = { class: "flex gap-1.5 h-1" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "absolute left-0 right-0 mt-10 transition-all duration-300" }
const _hoisted_8 = { class: "bg-brand-main rounded-xl p-2 text-white text-center relative" }
const _hoisted_9 = { class: "text-xs leading-relaxed" }

import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'DiamondDetailFluorescenceContent',
  props: {
    fluorescence: { default: "n" },
    mobileMode: { type: Boolean, default: false }
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

const host = process.env.VUE_APP_HOST;

const fluorescences = [
  {
    key: "f",
    label: "Medium",
    img: "/img/diamonds/filter/fluorescence/fluo_f@2x.jpg",
  },
  {
    key: "sl",
    label: "Weak",
    img: "/img/diamonds/filter/fluorescence/fluo_sl@2x.jpg",
  },
  {
    key: "n",
    label: "None",
    img: "/img/diamonds/filter/fluorescence/fluo_n@2x.jpg",
  },
];

const getNormalizedFluorescence = (f: string) => {
  if (!f) return "n";
  f = f.toUpperCase();
  if (f === "N" || f === "NONE" || f === "NON" || f === "KEINE") return "n";
  if (f === "SL" || f === "SLIGHT" || f === "WEAK" || f === "SCHWACH" || f === "FAINT") return "sl";
  if (f === "F" || f === "MEDIUM" || f === "MITTEL") return "f";
  return f.toLowerCase();
};

const getInitialIndex = () => {
  const fluorescenceValue = Array.isArray(props.fluorescence)
    ? props.fluorescence[0]
    : props.fluorescence;
  if (!fluorescenceValue) return 2;
  const normalized = getNormalizedFluorescence(fluorescenceValue);
  const index = fluorescences.findIndex((f) => f.key === normalized);
  return index !== -1 ? index : 2;
};

const selectedIndex = ref(getInitialIndex());

const isMobile = ref(window.innerWidth < 769);
const updateMobile = () => {
  isMobile.value = window.innerWidth < 769;
};

const isMobileMode = computed(() => props.mobileMode || isMobile.value);

watch(() => props.fluorescence, () => {
  selectedIndex.value = getInitialIndex();
});

const sliderRef = ref<HTMLElement | null>(null);
const isDragging = ref(false);

const updateIndexFromEvent = (e: MouseEvent | TouchEvent) => {
  if (!sliderRef.value) return;
  const rect = sliderRef.value.getBoundingClientRect();
  const clientX =
    "touches" in e ? e.touches[0].clientX : (e as MouseEvent).clientX;
  const offsetX = clientX - rect.left;
  let percentage = offsetX / rect.width;
  percentage = Math.max(0, Math.min(0.99, percentage));
  selectedIndex.value = Math.floor(percentage * fluorescences.length);
};

const startDragging = (e: MouseEvent | TouchEvent) => {
  isDragging.value = true;
  updateIndexFromEvent(e);
};

const handleMove = (e: MouseEvent | TouchEvent) => {
  if (isDragging.value) {
    updateIndexFromEvent(e);
  }
};

const stopDragging = () => {
  isDragging.value = false;
};

onMounted(() => {
  window.addEventListener("mousemove", handleMove);
  window.addEventListener("mouseup", stopDragging);
  window.addEventListener("touchmove", handleMove, { passive: false });
  window.addEventListener("touchend", stopDragging);
  window.addEventListener("resize", updateMobile);
});

onUnmounted(() => {
  window.removeEventListener("mousemove", handleMove);
  window.removeEventListener("mouseup", stopDragging);
  window.removeEventListener("touchmove", handleMove);
  window.removeEventListener("touchend", stopDragging);
  window.removeEventListener("resize", updateMobile);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['flex flex-col items-center gap-12', isMobileMode.value ? '' : 'md:flex-row'])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['w-full text-left', isMobileMode.value ? '' : 'md:w-1/3'])
    }, [
      _renderSlot(_ctx.$slots, "title", {
        selectedLabel: fluorescences[selectedIndex.value].label
      }, () => [
        _createElementVNode("h3", _hoisted_1, _toDisplayString(_unref(t)("components.diamonds.details.fluorescence.title")) + ": " + _toDisplayString(fluorescences[selectedIndex.value].label), 1)
      ]),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)("components.diamonds.details.fluorescence.text")), 1)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(['w-full', isMobileMode.value ? '' : 'md:w-2/3'])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(['flex justify-center items-end mb-6', isMobileMode.value ? '' : 'md:justify-between'])
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fluorescences, (f, index) => {
            return _createElementVNode("div", {
              key: f.key,
              class: _normalizeClass(["justify-center px-2", [
              selectedIndex.value === index ? 'flex' : (isMobileMode.value ? 'hidden' : 'hidden md:flex'),
              isMobileMode.value ? '' : 'md:flex-1',
            ]])
            }, [
              _createElementVNode("img", {
                src: _unref(host) + f.img,
                alt: f.label,
                class: _normalizeClass(["w-full transition-opacity duration-300 cursor-pointer", [
                isMobileMode.value ? 'max-w-[420px]' : 'max-w-[420px] md:max-w-[140px]',
                { 'md:opacity-90': !isMobileMode.value && selectedIndex.value !== index }
              ]]),
                onClick: ($event: any) => (selectedIndex.value = index)
              }, null, 10, _hoisted_4)
            ], 2)
          }), 64))
        ], 2),
        _createElementVNode("div", {
          class: "relative pb-32 cursor-pointer",
          ref_key: "sliderRef",
          ref: sliderRef,
          onMousedown: startDragging,
          onTouchstart: _withModifiers(startDragging, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fluorescences, (f, index) => {
              return _createElementVNode("div", {
                key: 'bar-' + f.key,
                class: "flex-1 cursor-pointer relative group",
                onClick: ($event: any) => (selectedIndex.value = index)
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["h-full w-full rounded-full transition-colors duration-300", 
                  selectedIndex.value === index ? 'bg-brand-main' : 'bg-brand-main/30'
                ])
                }, null, 2),
                _createElementVNode("span", {
                  class: _normalizeClass(["absolute top-2 left-1/2 -translate-x-1/2 text-sm transition-colors duration-300 whitespace-nowrap", 
                  selectedIndex.value === index
                    ? 'text-brand-main font-medium'
                    : 'text-gray-400'
                ])
                }, _toDisplayString(f.label), 3)
              ], 8, _hoisted_6)
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "absolute -top-2 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-b-[10px] border-b-brand-main transition-all duration-300",
                style: _normalizeStyle({
                  left: `calc(${selectedIndex.value * 33.33 + 16.66}% - 10px)`,
                })
              }, null, 4),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)("components.diamonds.details.fluorescence.descriptions." + fluorescences[selectedIndex.value].key)), 1)
            ])
          ])
        ], 544)
      ])
    ], 2)
  ], 2))
}
}

})